/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetRemarksTemplateResponse
 */
export interface ResponseGetRemarksTemplateResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseGetRemarksTemplateResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetRemarksTemplateResponse
     */
    template?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetRemarksTemplateResponse
     */
    title?: string;
}

/**
 * Check if a given object implements the ResponseGetRemarksTemplateResponse interface.
 */
export function instanceOfResponseGetRemarksTemplateResponse(value: object): value is ResponseGetRemarksTemplateResponse {
    return true;
}

export function ResponseGetRemarksTemplateResponseFromJSON(json: any): ResponseGetRemarksTemplateResponse {
    return ResponseGetRemarksTemplateResponseFromJSONTyped(json, false);
}

export function ResponseGetRemarksTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetRemarksTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'template': json['template'] == null ? undefined : json['template'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function ResponseGetRemarksTemplateResponseToJSON(json: any): ResponseGetRemarksTemplateResponse {
    return ResponseGetRemarksTemplateResponseToJSONTyped(json, false);
}

export function ResponseGetRemarksTemplateResponseToJSONTyped(value?: ResponseGetRemarksTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'template': value['template'],
        'title': value['title'],
    };
}

